import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useSession, signOut } from "../lib/auth.ts";
import { useStaff } from "../lib/staff.ts";
import { useOrg } from "../lib/useOrg.ts";
import { OrgSwitcher } from "./OrgSwitcher.tsx";
import { useMyOrgs } from "../lib/useMyOrgs.ts";

export function Layout() {
  const { data: session } = useSession();
  const { isStaff } = useStaff();
  const { isReseller } = useOrg();
  const { orgs } = useMyOrgs();
  const nav = useNavigate();

  // The active org can become suspended mid-session (staff block) — every
  // org-scoped API call then 403s with `org-blocked`. Rather than letting
  // each page show a generic error, replace the content area with one
  // honest notice; the switcher above stays usable as the way out.
  const activeId = session?.session.activeOrganizationId ?? null;
  const activeBlocked =
    activeId != null && !!orgs?.find((o) => o.id === activeId)?.blocked;

  return (
    <div className="layout">
      <header className="topbar">
        <div className="brand">BT-1851 Cloud</div>
        <nav aria-label="Primary">
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/devices">Devices</NavLink>
          <NavLink to="/tests">Tests</NavLink>
          <NavLink to="/organisation">Organisation</NavLink>
          <NavLink to="/integrations">Integrations</NavLink>
          {isReseller && <NavLink to="/reseller">Reseller</NavLink>}
          {isStaff && <NavLink to="/staff">Staff portal</NavLink>}
        </nav>
        <div className="spacer" />
        <OrgSwitcher />
        <NavLink to="/account" className="muted" aria-label="Account settings">
          {session?.user?.email}
        </NavLink>
        <button
          className="secondary"
          aria-label="Sign out"
          onClick={async () => {
            await signOut();
            nav("/login");
          }}
        >
          Sign out
        </button>
      </header>
      <main className="content">
        {activeBlocked ? (
          <div style={{ maxWidth: 560, margin: "4rem auto", textAlign: "center" }}>
            <h1>Organisation suspended</h1>
            <p className="muted">
              This organisation has been suspended. Its devices and test data
              are unavailable while the suspension is in place.
            </p>
            <p className="muted">
              If you believe this is a mistake, contact support. If you belong
              to another organisation, switch to it using the selector above.
            </p>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
